import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { TranslatePipe } from '@ngx-translate/core';
import { NavBarService } from '../../../services/nav-bar.service';

@Component({
  selector: 'app-workspace-menu',
  templateUrl: './workspace-menu.component.html',
  styleUrl: './workspace-menu.component.scss',
  imports: [TranslatePipe, MatIcon, MatMenuModule, CommonModule],
})
export class WorkspaceMenuComponent {
  @Output() saveWorkspace = new EventEmitter<void>();
  @Output() resetCurrentWorkspace = new EventEmitter<void>();
  @Output() resetFactoryWorkspace = new EventEmitter<void>();

  constructor(public navBarService: NavBarService) {}

  get isProjectViewEnabled(): boolean {
    return !this.navBarService.isProjectViewClosed;
  }

  toggleProjectView(event: MouseEvent): void {
    event.stopPropagation(); // Prevent menu from closing
    const newState = !this.navBarService.isProjectViewClosed;
    this.navBarService.isProjectViewClosed = newState;
    this.navBarService.isReportViewClosed = newState;
  }

  onSaveCurrentWorkspace(): void {
    this.saveWorkspace.emit();
  }

  onResetCurrentWorkspace(): void {
    this.resetCurrentWorkspace.emit();
  }

  onResetFactoryWorkspace(): void {
    this.resetFactoryWorkspace.emit();
  }
}

